export default __webpack_public_path__ + "static/media/logo.2887a144.svg";